import { requireAuth } from '@/features/auth/guards/require-auth'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { usersListQuery } from '@/features/references/users/users-query'
import { WarehousesPage } from '@/features/references/warehouses/pages/warehouses-page'
import { warehousesListQuery } from '@/features/references/warehouses/queries/warehouse-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

/**
 * Warehouse catalog list — admin-only довідник. Loader pre-awaits the three
 * datasets the list renders together (warehouses + projects + users) so the
 * page is fully hydrated by the time Suspense unblocks.
 */
export const Route = createFileRoute('/_app/references/warehouses/')({
  beforeLoad: requireAuth,
  loader: ({ context }) => {
    const qc = context.queryClient
    return Promise.all([
      qc.ensureQueryData(warehousesListQuery()),
      qc.ensureQueryData(projectsListQuery()),
      qc.ensureQueryData(usersListQuery()),
    ])
  },
  component: WarehousesPage,
  staticData: { crumb: messages.crumbs.refWarehouses },
})
